// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/transfers/sdd_collections_orchestrator/mandates/firstparty/v1/shared_create_mandate.proto

/* eslint-disable */

/** Type of client for the mandate. */
export const ApiClientKind = {
  /** CLIENT_KIND_UNSPECIFIED - Unspecified client kind. */
  CLIENT_KIND_UNSPECIFIED: "CLIENT_KIND_UNSPECIFIED",
  /** CLIENT_KIND_INDIVIDUAL - Individual client. */
  CLIENT_KIND_INDIVIDUAL: "CLIENT_KIND_INDIVIDUAL",
  /** CLIENT_KIND_COMPANY - Company client. */
  CLIENT_KIND_COMPANY: "CLIENT_KIND_COMPANY",
  /** CLIENT_KIND_FREELANCER - Freelancer client. */
  CLIENT_KIND_FREELANCER: "CLIENT_KIND_FREELANCER",
} as const;

export type ApiClientKind = typeof ApiClientKind[keyof typeof ApiClientKind];

export namespace ApiClientKind {
  export type CLIENT_KIND_UNSPECIFIED = typeof ApiClientKind.CLIENT_KIND_UNSPECIFIED;
  export type CLIENT_KIND_INDIVIDUAL = typeof ApiClientKind.CLIENT_KIND_INDIVIDUAL;
  export type CLIENT_KIND_COMPANY = typeof ApiClientKind.CLIENT_KIND_COMPANY;
  export type CLIENT_KIND_FREELANCER = typeof ApiClientKind.CLIENT_KIND_FREELANCER;
}

export function apiClientKindFromJSON(object: any): ApiClientKind {
  switch (object) {
    case 0:
    case "CLIENT_KIND_UNSPECIFIED":
      return ApiClientKind.CLIENT_KIND_UNSPECIFIED;
    case 1:
    case "CLIENT_KIND_INDIVIDUAL":
      return ApiClientKind.CLIENT_KIND_INDIVIDUAL;
    case 2:
    case "CLIENT_KIND_COMPANY":
      return ApiClientKind.CLIENT_KIND_COMPANY;
    case 3:
    case "CLIENT_KIND_FREELANCER":
      return ApiClientKind.CLIENT_KIND_FREELANCER;
    default:
      return ApiClientKind.CLIENT_KIND_UNSPECIFIED;
  }
}

export function apiClientKindToJSON(object: ApiClientKind): string {
  switch (object) {
    case ApiClientKind.CLIENT_KIND_UNSPECIFIED:
      return "CLIENT_KIND_UNSPECIFIED";
    case ApiClientKind.CLIENT_KIND_INDIVIDUAL:
      return "CLIENT_KIND_INDIVIDUAL";
    case ApiClientKind.CLIENT_KIND_COMPANY:
      return "CLIENT_KIND_COMPANY";
    case ApiClientKind.CLIENT_KIND_FREELANCER:
      return "CLIENT_KIND_FREELANCER";
    default:
      return "CLIENT_KIND_UNSPECIFIED";
  }
}

/** Request for creating a mandate via public invitation link. */
export interface ApiCreatePublicMandateRequest {
  /** Unique identifier for the invitation link from URL path. */
  readonly invitationLinkId: string;
  /** Type of client. */
  readonly kind: ApiClientKind;
  /** Client's first name. */
  readonly companyName?:
    | string
    | null
    | undefined;
  /** Client's first name. */
  readonly firstName?:
    | string
    | null
    | undefined;
  /** Client's last name. */
  readonly lastName?:
    | string
    | null
    | undefined;
  /** Client's email address. */
  readonly email: string;
  /** Client's street address. */
  readonly address: string;
  /** Client's city. */
  readonly city: string;
  /** Client's postal/zip code. */
  readonly zipCode: string;
  /** Client's country code (ISO 3166-1 alpha-2 e.g., "fr", "en"). */
  readonly countryCode: string;
  /** Client's IBAN for the mandate. */
  readonly iban: string;
  /** Client's city. */
  readonly province?: string | null | undefined;
}

/**
 * Response for successful mandate creation.
 * Empty response for successful creation (200 OK).
 */
export interface ApiCreatePublicMandateResponse {
}

/** Custom application error codes for the CreatePublicMandate endpoint. */
export interface ApiCreatePublicMandateErrors {
}

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export const ApiCreatePublicMandateErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_CODE_UNSPECIFIED - Unspecified validation error. */
  BAD_REQUEST_ERROR_CODE_UNSPECIFIED: "BAD_REQUEST_ERROR_CODE_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD - Missing required field. */
  BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD: "BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD",
  /** BAD_REQUEST_ERROR_CODE_FORMAT_ERROR - The request has an invalid format, source and detail fields contain more information. */
  BAD_REQUEST_ERROR_CODE_FORMAT_ERROR: "BAD_REQUEST_ERROR_CODE_FORMAT_ERROR",
} as const;

export type ApiCreatePublicMandateErrorsBadRequestError =
  typeof ApiCreatePublicMandateErrorsBadRequestError[keyof typeof ApiCreatePublicMandateErrorsBadRequestError];

export namespace ApiCreatePublicMandateErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_CODE_UNSPECIFIED =
    typeof ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD =
    typeof ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD;
  export type BAD_REQUEST_ERROR_CODE_FORMAT_ERROR =
    typeof ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_FORMAT_ERROR;
}

export function apiCreatePublicMandateErrorsBadRequestErrorFromJSON(
  object: any,
): ApiCreatePublicMandateErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_CODE_UNSPECIFIED":
      return ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD":
      return ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD;
    case 2:
    case "BAD_REQUEST_ERROR_CODE_FORMAT_ERROR":
      return ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_FORMAT_ERROR;
    default:
      return ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_UNSPECIFIED;
  }
}

export function apiCreatePublicMandateErrorsBadRequestErrorToJSON(
  object: ApiCreatePublicMandateErrorsBadRequestError,
): string {
  switch (object) {
    case ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_CODE_UNSPECIFIED";
    case ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD:
      return "BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD";
    case ApiCreatePublicMandateErrorsBadRequestError.BAD_REQUEST_ERROR_CODE_FORMAT_ERROR:
      return "BAD_REQUEST_ERROR_CODE_FORMAT_ERROR";
    default:
      return "BAD_REQUEST_ERROR_CODE_UNSPECIFIED";
  }
}

export const ApiCreatePublicMandateRequest: MessageFns<ApiCreatePublicMandateRequest> = {
  fromJSON(object: any): ApiCreatePublicMandateRequest {
    return {
      invitationLinkId: isSet(object.invitationLinkId) ? globalThis.String(object.invitationLinkId) : "",
      kind: isSet(object.kind) ? apiClientKindFromJSON(object.kind) : ApiClientKind.CLIENT_KIND_UNSPECIFIED,
      companyName: isSet(object.companyName) ? globalThis.String(object.companyName) : null,
      firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : null,
      lastName: isSet(object.lastName) ? globalThis.String(object.lastName) : null,
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      zipCode: isSet(object.zipCode) ? globalThis.String(object.zipCode) : "",
      countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
      iban: isSet(object.iban) ? globalThis.String(object.iban) : "",
      province: isSet(object.province) ? globalThis.String(object.province) : null,
    };
  },

  toJSON(message: ApiCreatePublicMandateRequest): unknown {
    const obj: any = {};
    if (message.invitationLinkId !== "") {
      obj.invitationLinkId = message.invitationLinkId;
    }
    if (message.kind !== ApiClientKind.CLIENT_KIND_UNSPECIFIED) {
      obj.kind = apiClientKindToJSON(message.kind);
    }
    if (message.companyName !== undefined && message.companyName !== null) {
      obj.companyName = message.companyName;
    }
    if (message.firstName !== undefined && message.firstName !== null) {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== undefined && message.lastName !== null) {
      obj.lastName = message.lastName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.zipCode !== "") {
      obj.zipCode = message.zipCode;
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.iban !== "") {
      obj.iban = message.iban;
    }
    if (message.province !== undefined && message.province !== null) {
      obj.province = message.province;
    }
    return obj;
  },
};

export const ApiCreatePublicMandateResponse: MessageFns<ApiCreatePublicMandateResponse> = {
  fromJSON(_: any): ApiCreatePublicMandateResponse {
    return {};
  },

  toJSON(_: ApiCreatePublicMandateResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiCreatePublicMandateErrors: MessageFns<ApiCreatePublicMandateErrors> = {
  fromJSON(_: any): ApiCreatePublicMandateErrors {
    return {};
  },

  toJSON(_: ApiCreatePublicMandateErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
